import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "select-file__list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "默认下载目录", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "全部磁盘目录", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "历史下载目录", -1)
const _hoisted_7 = { class: "file-item" }
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

import { onMounted, ref, computed, PropType, watch } from 'vue'
import { getDir } from '@remote/api/files'
import Icons from '@remote/utils/static-icons'
import Checkbox from '@remote/components/Checkbox.vue'
import { store } from '@remote/store'
import { IconPageLeft, IconDelete } from '@xunlei/thunder-icon-vue'
import { useBaseStore } from '@remote/store/base'
import { useDownloadStore } from '@remote/store/download'
import FileExplorerList from './FileExplorerList.vue'
import { openPopMenu } from '@remote/utils/dialog'
import { toast, vibrate } from '@remote/utils'
import { replaceRootAlias, createAliasMapFromDownloads } from '@remote/utils'
import { sleep } from '@shared/utils'
import { captureException, captureMessage } from '@sentry/vue'

interface CheckableFile extends API_FILE.DriveFile {
  __isChecked?: boolean
}

interface CheckableHistory extends API_DEVICE.HistoryDownloadPath {
  __isChecked?: boolean
}

// TODO: loading

export default /*#__PURE__*/_defineComponent({
  props: {
  rootFileID: {
    type: String,
    default: '',
  },
  type: {
    type: String as PropType<'checkbox' | 'radio'>,
    default: 'checkbox',
  },
  maxChooseCount: {
    type: Number,
    default: -1, // 不作限制
  },
  hideHistory: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  defaultSelect: {
    type: Boolean,
    default: true,
  },
  defaultSelectPath: {
    type: String,
    default: '',
  },
},
  emits: ["update:chosenList", "update:isLoading"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:chosenList', chosenList: (CheckableFile | CheckableHistory)[])
  (event: 'update:isLoading', value: boolean)
}), expose: any, slots: any, attrs: any }) {

const props = __props





const downloadStore = useDownloadStore()

// watch接口返回的下载路径
const downloadPath = computed(() => store.state.deviceInfoWatchData.downloads)

// 默认下载路径: watch接口返回且is_root_path为false的下载路径
const defaultDownloadPath = computed(() => downloadPath.value?.filter(i => !i.is_root_path))

// 全部磁盘路径: watch接口返回且is_root_path为true的下载路径
const diskPath = computed(() => downloadPath.value?.filter(i => i.is_root_path))

const aliasMap = computed(() => createAliasMapFromDownloads(store.state?.deviceInfoWatchData?.downloads ?? []))

const pathSeparator = computed(() => {
  return store.state.deviceInfoWatchData.path_separator ?? '/'
})

// 如果路径结尾没有 '/'，那么补充一个
const endPathWithSlash = (path: string) => {
  if (path.endsWith(pathSeparator.value)) {
    return path
  }
  return path + pathSeparator.value
}

const defaultDownloadPathFile = computed(() => {
  if (defaultDownloadPath.value) {
    return defaultDownloadPath.value.map(path => {
      const pathWithSlash = endPathWithSlash(path.path ?? '')
      return downloadStore.rootDirectory.find(i => {
        const realPathWithSlash = endPathWithSlash(i?.params?.RealPath ?? '')
        return realPathWithSlash === pathWithSlash
      })
    }).filter(Boolean) as CheckableFile[]
  }
  return []
})

const diskPathFile = computed(() => {
  if (diskPath.value) {
    return diskPath.value.map(path => {
      const pathWithSlash = endPathWithSlash(path.path ?? '')
      return downloadStore.rootDirectory.find(i => {
        const realPathWithSlash = endPathWithSlash(i?.params?.RealPath ?? '')
        return realPathWithSlash === pathWithSlash
      })
    }).filter(Boolean) as CheckableFile[]
  }
  return []
})

/**
 * 如果历史记录里有默认下载路径或者磁盘目录，那么不重复展示。
 */
const deduplicateHistoryPath = computed(() => {
  const historyPath = downloadStore.historyDownloadPath
  const deduplicateResult: CheckableHistory[] = []
  historyPath.forEach(path => {
    const curRealPath = endPathWithSlash(path.RealPath ?? '')
    if (defaultDownloadPathFile.value.find(i => endPathWithSlash(i?.params?.RealPath ?? '') === curRealPath)) {
      return
    }
    if (diskPathFile.value.find(i => endPathWithSlash(i?.params?.RealPath ?? '') === curRealPath)) {
      return
    }
    deduplicateResult.push(path)
  })
  return deduplicateResult
})

const checkboxType = computed(() => {
  return props.maxChooseCount === 1 ? 'radio' : 'checkbox'
})

const currentList = ref<CheckableFile[]>([])

const checkedFilesAndHistory = computed(() => {
  return [
    ...defaultDownloadPathFile.value.filter(i => i.__isChecked),
    ...diskPathFile.value.filter(i => i.__isChecked),
    ...currentList.value.filter(i => i.__isChecked),
    ...deduplicateHistoryPath.value.filter(i => i.__isChecked),
  ]
})

const clearAllCheckedFiles = () => {
  [defaultDownloadPathFile, diskPathFile, currentList].forEach(list => {
    list.value.filter(i => i.__isChecked).forEach(i => i.__isChecked = false)
  })
}

const clearAllCheckedHistory = () => {
  (downloadStore.historyDownloadPath as CheckableHistory[]).forEach(i => i.__isChecked = false)
}

const typeGuard = (val: (API_FILE.DriveFile | API_DEVICE.HistoryDownloadPath)): val is API_FILE.DriveFile => {
  return !!(val as API_FILE.DriveFile).id
}

const onCheckFileOrHistory = (target: CheckableFile | CheckableHistory) => {
  if (props.isLoading) {
    return
  }
  if (typeGuard(target) && target.params?.is_write !== 'true') {
    return
  }
  vibrate([50])
  // 如果不限制选择个数，那么直接勾选 / 取消勾选
  if (props.maxChooseCount === -1) {
    target.__isChecked = !target.__isChecked
    return 
  }
  // 如果只能选一个，那么要取消掉之前的勾选，然后选中这一个。
  if (props.maxChooseCount === 1) {
    clearAllCheckedFiles()
    clearAllCheckedHistory()
    target.__isChecked = true
    return
  }
  if (props.maxChooseCount > 1) {
    if (checkedFilesAndHistory.value.length < props.maxChooseCount) {
      target.__isChecked = true
    }
    return 
  }
}

const pathFileStack = ref<(CheckableFile | null)[]>([])

const currentRootFile = ref<CheckableFile | null>(null)
const lastRootFileID = computed(() => {
  if (pathFileStack.value.length < 1) return ''
  return pathFileStack.value[pathFileStack.value.length - 1]?.parent_id
})

const target = computed(() => {
  return store.state.deviceInfoWatchData.target ?? ''
})

/**
 * 如果要扩展成可以选择文件的弹窗，这里兜底要判断文件后缀展示图标
 */
const getIcon = (file?: API_FILE.DriveFile | null) => {
  if (file?.icon_link) {
    return file.icon_link
  }
  return Icons.dir
}

const wrapFilesWithCheck = (files: API_FILE.DriveFile[]): CheckableFile[] => {
  return files.map(file => {
    return {
      ...file,
      __isChecked: false,
    }
  })
}

watch(checkedFilesAndHistory, (val) => {
  emit('update:chosenList', val)
})

const enterDirectory = async (file: API_FILE.DriveFile) => {
  try {
    vibrate([50])
    if (file.id) {

      emit('update:isLoading', true)
      const result = await getDir(target.value, file.id) // TODO: load all
      emit('update:isLoading', false)
      currentRootFile.value = { ...file, __isChecked: false }
      pathFileStack.value.push(currentRootFile.value)
      currentList.value = wrapFilesWithCheck(result?.files ?? [])
    }
    clearAllCheckedFiles()
    clearAllCheckedHistory()
  } catch (error) {
    emit('update:isLoading', false)
    console.error(error)
  }
}

const backDirectory = async () => {
  try {
    vibrate([50])
    if (pathFileStack.value.length > 0) {
      emit('update:isLoading', true)
      const result = await getDir(target.value, lastRootFileID.value ?? '')
      emit('update:isLoading', false)
      pathFileStack.value.pop()
      currentRootFile.value = pathFileStack.value[pathFileStack.value.length - 1] ?? null
      currentList.value = wrapFilesWithCheck(result?.files ?? [])
    }
    clearAllCheckedFiles()
    clearAllCheckedHistory()
  } catch (error) {
    emit('update:isLoading', false)
    console.error(error)
  }
}

/**
 * 传入一个路径，看这个路径是否存在于 默认下载目录 或 全部磁盘目录 或 历史下载记录 中，有的话就选中
 */
const selectPath = (path: string) => {
  const pathWithSlash = endPathWithSlash(path)
  // 
  const match = (list: CheckableFile[] | CheckableHistory[]) => {
    const determineListType = (list: CheckableFile[] | CheckableHistory[]): list is CheckableFile[] => {
      return (list as CheckableFile[])[0]?.id !== undefined
    }
    let found
    if (determineListType(list)) {
      found = list.find(i => {
        return endPathWithSlash(i?.params?.RealPath ?? '') === pathWithSlash
      })
    } else {
      found = list.find(i => {
        return endPathWithSlash(i?.RealPath ?? '') === pathWithSlash
      })
    }
    if (found) {
      found.__isChecked = true
      return true
    }
    return false
  }
  // 判断是否存在于默认下载目录中
  const isInDefaultDownloadPath = match(defaultDownloadPathFile.value)
  if (!isInDefaultDownloadPath) {
    const isInDiskPath = match(diskPathFile.value)
    if (!isInDiskPath) {
      match(downloadStore.historyDownloadPath as CheckableHistory[])
    }
  }
}

/**
 * 临时解决方案：
 * - 字符数不超过20 不缩略; e.g. /volume1/迅雷/下载 => /volume1/迅雷/下载
 * - 字符数超过20
 *    - 生态版 缩略至 迅雷; e.g. /var/package/xxxxxx/xxxxxx/迅雷/下载 => .../迅雷/下载
 *    - 厂商版 缩略至 迅雷下载; e.g. /var/package/xxxxxx/xxxxxx/迅雷下载 => .../迅雷下载
 */
const shortenDownloadPath = (realPath: string) => {
  /**
   * @description 在路径中寻找特定目录名称并缩减，找不到时返回原路径。
   * 
   * @example: reduceUntilWord = '迅雷下载'
   * /xxx/xxx/迅雷下载/ => .../迅雷下载/
   * /xxx/xxx/迅雷下载/a/b => .../迅雷下载/a/b
   * 
   * @example /xxx/xxx/xxx (是什么就是什么)
   * 
  */
  const reducePathName = (path: string, reduceUntilWord = '迅雷') => {
    const splitPath = path.split('/')
    const rootIndex = splitPath.indexOf(reduceUntilWord)
    if (rootIndex >= 0) {
      return ['...', ...splitPath.slice(rootIndex)].join('/')
    } else {
      return path
    }
  }
  
  // 华为分支，是只替换，不做缩略的。合并时以目前分支为准（将华为的合并过来）
  const aliasReplacedPath = replaceRootAlias({
    path: realPath ?? '',
    aliasMap: createAliasMapFromDownloads(store.state?.deviceInfoWatchData?.downloads) ?? {},
  })

  if (aliasReplacedPath === realPath) {
    // 替换前后没变化，说明没有别名，需要缩略
    if (store.state.deviceInfoWatchData.privilege === 'PAN_CLI_PREVIEW') {
      return reducePathName(aliasReplacedPath, '迅雷')
    }
    return reducePathName(aliasReplacedPath, '迅雷下载')
  } else {
    return aliasReplacedPath
  }
}


const selectDefaultPath = () => {
  if (props.defaultSelectPath === '' && checkedFilesAndHistory.value.length === 0) {
    if (defaultDownloadPathFile.value.length > 0) {
      defaultDownloadPathFile.value[0].__isChecked = true
    }
  } else {
    selectPath(props.defaultSelectPath)
  }
}

watch(() => props.defaultSelectPath, selectDefaultPath)

const baseStore = useBaseStore()

onMounted(async () => {
  try {
    // 之前可能会有遗留状态，进来之前先清一下。
    clearAllCheckedFiles()
    clearAllCheckedHistory()
    emit('update:isLoading', true)
    await baseStore.untilTargetReady(),
    await Promise.all([
      downloadStore.getHistoryDownloadPath(),
      downloadStore.refreshRootDirectory(),
    ])
    if (defaultDownloadPathFile.value.length > 0) {
      captureMessage('获取历史下载路径成功')
    }
  } catch(error) {
    console.error('获取历史下载路径失败')
    captureException('获取历史下载路径失败', {
      extra: {
        err: error,
        diskPath: diskPath.value,
        defaultDownloadPath: defaultDownloadPath.value,
        rootDirectory: downloadStore.rootDirectory,
      },
    })
    toast('获取历史下载路径失败，请检查网络环境后重试')
  } finally {
    selectDefaultPath()
    emit('update:isLoading', false)
  }
})

const onDeleteHistory = async (path: API_DEVICE.HistoryDownloadPath) => {
  const res = await openPopMenu({
    title: '确认删除？',
    danger: [0],
    themeClass: 'is-light',
    options: ['确认', '取消'],
  })
  if (res === '确认') {
    await downloadStore.deleteHistoryDownloadPath(path.Id ?? '')
    // 如果删除历史路径后，当前没有选中的路径，那么选中第一个默认路径。
    // DIRTY move here.
    // 如果删除历史路径后，且store中存储的当前选中下载路径是刚刚被删掉的下载路径
    // 那么将当前选择的下载路径改成默认路径
    if (store.state.pathFolderId === path.Id && checkedFilesAndHistory.value.length === 0) {
      defaultDownloadPathFile.value[0].__isChecked = true
      const file = defaultDownloadPathFile.value[0]
      store.commit('update', {
        pathFolderId: file?.id,
        pathFolderName: file?.params?.RealPath,
      })
    }
    toast('删除成功')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "navigation",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (backDirectory()), ["stop"]))
    }, [
      _createVNode(_unref(IconPageLeft), {
        width: "16",
        height: "16"
      }),
      _createElementVNode("img", {
        src: getIcon(currentRootFile.value)
      }, null, 8, _hoisted_2),
      _createElementVNode("p", null, _toDisplayString(currentRootFile.value?.name ?? '/'), 1)
    ], 512), [
      [_vShow, pathFileStack.value.length !== 0]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (pathFileStack.value.length === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(defaultDownloadPathFile)?.length ?? 0 > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createVNode(FileExplorerList, {
                    list: _unref(defaultDownloadPathFile),
                    type: _unref(checkboxType),
                    onEnter: enterDirectory,
                    onCheck: onCheckFileOrHistory,
                    "alias-map": _unref(aliasMap)
                  }, null, 8, ["list", "type", "alias-map"])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(diskPathFile)?.length ?? 0 > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(FileExplorerList, {
                    list: _unref(diskPathFile),
                    type: _unref(checkboxType),
                    onEnter: enterDirectory,
                    onCheck: onCheckFileOrHistory,
                    "alias-map": _unref(aliasMap)
                  }, null, 8, ["list", "type", "alias-map"])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(deduplicateHistoryPath).length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_6,
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deduplicateHistoryPath), (path) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: path.RealPath
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(Checkbox, {
                            value: path.__isChecked,
                            "onUpdate:value": ($event: any) => (onCheckFileOrHistory(path)),
                            type: _unref(checkboxType)
                          }, null, 8, ["value", "onUpdate:value", "type"])
                        ]),
                        _createElementVNode("img", {
                          src: _unref(Icons).dir,
                          onClick: ($event: any) => (onCheckFileOrHistory(path))
                        }, null, 8, _hoisted_8),
                        _createElementVNode("p", {
                          class: "history",
                          onClick: ($event: any) => (onCheckFileOrHistory(path))
                        }, _toDisplayString(shortenDownloadPath(path.RealPath ?? '')), 9, _hoisted_9),
                        _createElementVNode("div", {
                          class: "delete",
                          onClick: ($event: any) => (onDeleteHistory(path))
                        }, [
                          _createVNode(_unref(IconDelete), {
                            width: "18",
                            height: "18"
                          })
                        ], 8, _hoisted_10)
                      ]))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(FileExplorerList, {
        list: currentList.value,
        type: _unref(checkboxType),
        indent: pathFileStack.value.length !== 0,
        "alias-map": _unref(aliasMap),
        onCheck: onCheckFileOrHistory,
        onEnter: enterDirectory
      }, null, 8, ["list", "type", "indent", "alias-map"]), [
        [_vShow, pathFileStack.value.length > 0]
      ])
    ])
  ]))
}
}

})